export const SidebarLinks = [
  {
    key: '1',
    name: 'organization',
  },
  {
    key: '2',
    name: 'aoi',
  },
  {
    key: '3',
    name: 'site',
  },
  {
    key: '4',
    name: 'qgis',
  },
]
